import React from 'react';
import './Header.css';

const Header = () => (
  <header className="header">
    <h1>Tina's artworks</h1>
    <p className="subtitle">
      Hi! My name is Tina and I am 11 years old. I love drawing and I wanted to share some of my projects with you.
    </p>
  </header>
);

export default Header; 